import React from 'react';
import { StyledMenu } from './Menu.styled';
import { useHistory } from 'react-router-dom';
import { validURL } from '../../../utils/utils';
import RenderSvgIcon from '../../RenderSvgIcon';
import { DISPLAY_ELEMENT_TYPE } from '../../../config/constants';

const MenuCustom = ({ open, envUi, ...props }) => {
  const history = useHistory();
  const isHidden = !!open;
  const tabIndex = isHidden ? 0 : -1;

  const handleCheckPath = (path) => {
    if (path === '/') {
      return window.location.href = '/';
    }
    history.push({ pathname: path });
  };

  const renderIconMenu = (iconPath) => {
    let src = '';
    try {
      // Link public
      if (validURL(iconPath)) {
        return (<img src={iconPath} alt="" />);
      }

      const str = `${iconPath}`.split('\\').join('/').split('/');

      if (str && str.length && str[str.length - 1].includes('.')) {
        if (str[str.length - 1].toLowerCase().includes('.svg')) {
          return (<RenderSvgIcon
            name={str[str.length - 1].split('.')[0]}
            fill="var(--sub-color)"
            style={{ fill: 'currentColor' }}
            className={'d-svg'}
          />);
        }
        // Other .png
        src = require(`assets/image-icon/${str[str.length - 1]}`); // Fix name `assets/image-icon` not use params form db
      }
    } catch (e) {
    }

    return <img src={src} alt="" />;
  };

  const renderContentLink = (context) => {
    let ctxLink = context.link;
    return ctxLink;
  };

  return (
    <StyledMenu open={open} aria-hidden={!isHidden} {...props} className={'d-menu-wrapper'}>
      <ul>
        {(props.dataHumburgerCustom || []).map((ele, index) => {
          // Hidden
          if (+ele.displaySetting !== DISPLAY_ELEMENT_TYPE.ON) {
            return null;
          }
          return (
            <li tabIndex={tabIndex}
                key={index}
                onClick={() => handleCheckPath(renderContentLink(ele))}
            >
              {renderIconMenu(ele?.iconImage)}
              <span className="font-4">{ele.content}</span></li>);
        })}
      </ul>
    </StyledMenu>
  );
};

export default MenuCustom;
